interface SeverityBadgeProps {
  severity: number;
  showLabel?: boolean;
}

export function SeverityBadge({ severity, showLabel = true }: SeverityBadgeProps) {
  const getSeverityConfig = (sev: number) => {
    if (sev === 0) {
      return { color: 'bg-green-100 text-green-800', icon: '✓', label: 'Match', title: 'Sévérité 0 — Match : la valeur extraite correspond au GT.' };
    }
    if (sev === 1) {
      return { color: 'bg-yellow-100 text-yellow-800', icon: '⚠', label: 'Mineure', title: 'Sévérité 1 — Mineure : écart de faible impact (formatage, accents, casse).' };
    }
    if (sev === 2) {
      return { color: 'bg-orange-100 text-orange-800', icon: '⚠', label: 'Moyenne', title: 'Sévérité 2 — Moyenne : écart significatif à corriger.' };
    }
    return { color: 'bg-red-100 text-red-800', icon: '✕', label: 'Critique', title: 'Sévérité 3 — Critique : erreur majeure (valeur manquante, fausse ou aberrante).' };
  };

  const config = getSeverityConfig(severity);

  return (
    <span
      className={`inline-flex items-center px-2 py-1 rounded text-xs font-medium ${config.color}`}
      title={config.title}
    >
      <span className="mr-1">{config.icon}</span>
      {showLabel && config.label}
    </span>
  );
}
